import { render } from "./whats-next.vue?vue&type=template&id=73882268"
import script from "./whats-next.vue?vue&type=script&lang=js"
export * from "./whats-next.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__